import { Box, type BoxProps } from '@mantine/core';
import { textMatch } from 'lib/textMatch';
import { Fragment } from 'react';

export type HighlightProps = BoxProps &
  (
    | {
        highlight: string[] | undefined;
        query?: undefined;
        text?: undefined;
      }
    | {
        highlight?: undefined;
        query: string;
        text: string;
      }
  );

export default function Highlight({ highlight, query, text, ...props }: HighlightProps) {
  const chunks =
    highlight !== undefined ? highlight : text !== undefined && query !== undefined ? (textMatch(text, query)?.chunks ?? []) : [];
  let isMatch = false;

  return (
    <Box
      component="span"
      {...props}
      css={{
        '& > span': {
          // color: 'var(--mantine-color-black)',
          // backgroundColor: 'var(--mantine-color-yellow-3)',
          fontWeight: 'bold',
        },
      }}
    >
      {chunks.map((chunk, index) => {
        if ((isMatch = !isMatch)) {
          return <Fragment key={index}>{chunk}</Fragment>;
        }

        return <span key={index}>{chunk}</span>;
      })}
    </Box>
  );
}
